import React from 'react';
// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HelmetProvider } from 'react-helmet-async';
import './styles/styles.scss';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeContextProvider } from './contexts/themeContext';
import { AuthContextProvider } from './contexts/authContext';
import PrerenderReady from './components/seo/PrerenderReady';
import GARouteTracker from './analytics/GARouteTracker';
import { installJourneyHeader } from './observability/journey';
import { resolvePreviewAccess } from './preview/previewAccess';
import './i18n';

// Before anything can call the API: tag every request with this visit's journey id.
installJourneyHeader(process.env.REACT_APP_SERVER_URL);

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const children = (
	<ErrorBoundary>
		<HelmetProvider>
			<GoogleOAuthProvider clientId={googleClientId}>
				<AuthContextProvider>
					<ThemeContextProvider>
						<Router>
							<React.StrictMode>
								<PrerenderReady />
								<GARouteTracker />
								<App />
							</React.StrictMode>
						</Router>
					</ThemeContextProvider>
				</AuthContextProvider>
			</GoogleOAuthProvider>
		</HelmetProvider>
	</ErrorBoundary>
);

const container = document.getElementById('root');

// Pre-launch: settle any ?preview= pass before the routes pick coming-soon vs full site.
resolvePreviewAccess().finally(() => {
	// ReactDOM.render(children, container); // For React 17
	createRoot(container as Element).render(children); // For React 18
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
